<div class="scroll-indicator" *ngIf="isVisible" (click)="scrollToBottom()">
  <i class="material-icons">keyboard_arrow_down</i>
</div>
